import { Grid } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  rowSpacing?: number;
  columnSpacing?: number;
}

const DreamcaseGrid = ({
  children,
  rowSpacing = 3,
  columnSpacing = 0,
}: Props): JSX.Element => {
  return (
    <Grid
      container
      rowSpacing={rowSpacing}
      columnSpacing={columnSpacing}
      sx={{
        mt: { xs: 10, md: 12 },
        maxWidth: { xs: 0.9, md: 0.7, xl: 0.5 },
        marginLeft: "auto",
        marginRight: "auto",
        textAlign: { xs: "center", md: "left" },
      }}
    >
      {children}
    </Grid>
  );
};

export default DreamcaseGrid;
